// extracted by mini-css-extract-plugin
export default {"header":"Table_header__FjvvX","link":"Table_link__Ld32k","active":"Table_active__Q3xTK","inactive":"Table_inactive__GwneQ"};